//#region Styles
import {
    Container, 
    StepNumber, 
    Description, 
    Line 
} from "./styles";
//#endregion
//#region Icons
import RoundedCheckIcon from "icons/RoundedCheckIcon";
//#endregion

const StepIndex = ({
    children, 
    step, 
    filling = false, 
    passed = false, 
    isLast = false
}) => {
    return (
        <>
            <Container>
                {passed 
                ? <span><RoundedCheckIcon/></span>
                : <StepNumber className={
                    filling ? "filling" : ""}>
                    <span>{step}</span>
                </StepNumber>}
                <Description className={(filling || passed) ? "filling" : ""}>
                    {children}
                </Description>
            </Container>
            {!isLast && <Line className={passed ? "filling" : ""}/>}
        </>
    );
}

export default StepIndex;